<template>
    <b-row>
        <b-col>
            <b-row v-bind:key="index" align-h="center" class="m-0" v-for="(item,index) in listItems">
                <b-col md="3">
                    <b-img :src="baseUrl + item.image.value" fluid-grow/>
                </b-col>
                <b-col md="3">
                    <h3>asd</h3>
                    <div v-html="item.description.value">
                        {{item.description.value}}
                    </div>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>
<script>
    import ContentAPI from "@shared/_api/cms/content";

    export default {
        name: 'list',
        data: function () {
            return {
                listItems : []
            }
        },
        mounted() {
            ContentAPI.fetchListByName(this.$route.params.resource).then(result => {
                this.listItems = result;
            })
        }
    }
</script>